import { render, staticRenderFns } from "./CalloutBlock.vue?vue&type=template&id=31003dca&scoped=true&"
import script from "./CalloutBlock.vue?vue&type=script&lang=js&"
export * from "./CalloutBlock.vue?vue&type=script&lang=js&"
import style0 from "./CalloutBlock.vue?vue&type=style&index=0&id=31003dca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31003dca",
  null
  
)

export default component.exports